export default function campaignFormValidation(report) {
  // returned, defines if we have errors or not;
  let hasErrors = false;

  // returned, used to setState to inform the users of the errors;
  const errors = {};

  // campaign name is required;
  if (report.name === ``) {
    errors.name = "Campaign Name is a required field.";
    hasErrors = true;
  }

  return {
    errors: errors, // return for setState to tell the user what went wrong;
    hasErrors: hasErrors // return true/false so the submit works/doesn't;
  };
}
